// extracted by mini-css-extract-plugin
export default {"wrapper":"SequenceType_wrapper__fQfcG","row":"SequenceType_row__G-hHA","checkbox":"SequenceType_checkbox__uNJXZ"};